import { useUser } from '.';

export const useCustomerOnly = (number: number) => {
  const user = useUser();
  return user?.kundennummer === number;
};
